<template>
    <div class="window-wrapper window-client-check-error-4">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Не удалось отправить письмо по следующим email: {{getRecepients(letter.recepientList)}}.<br> Вы можете назначить других адресатов из списка контактных лиц Клиента или связаться с адресатами в социальных сетях и назначить новый email.</div>
                    <div class="form-field-input-2">
                        <label>Социальные сети адресатов:</label>
                        <div class="field-input-wrapper">
                            <div v-for="social in socialList" class="field-input-soc">{{ social }}</div>
                        </div>
                    </div>

                    <div class="form-field-input-2">
                        <label>Кому</label>
                        <div class="field-input-wrapper">
                            <select v-model="addresseeEmail" class="select-contacts">
                                <option value="">Не выбрано</option>
                                <option v-for="addressee in addresseeList" :value="addressee.email">{{
                                        addressee.surname + ' ' + addressee.name + (addressee.patronymic == null ? '' : ' ' + addressee.patronymic)
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="new-email-block">
                        <div class="form-field-input-2"
                             :class="{'error-field' : emailIncorrect}"
                        >
                            <label>Введите email</label>
                            <div class="field-input-wrapper">
                                <input v-model="newEmail" type="text" class="field-text" required>
                                <div v-show="emailIncorrect" class="msg-form msg-error-field">
                                    Введите корректный email
                                </div>
                            </div>
                        </div>
                        <div class="button-block">
                            <button @click="sendLetter" class="button button-dark button-close-window" :disabled="isDisabled">Отправить</button>
                            <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SendError4Window",
    props: ["addresseeList", "letter", "socialList"],
    data() {
        return {
            addresseeEmail: '',
            newEmail: '',
            emailIncorrect: false,
        }
    },
    computed: {
        correctEmail() {
            if (this.newEmail === '') {
                return true;
            }
            let reg = new RegExp("^([a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$");
            this.emailIncorrect = !reg.test(this.newEmail);
            return reg.test(this.newEmail);
        },
        isDisabled() {
            return this.addresseeEmail === '' && (this.newEmail.length === 0 || !this.correctEmail);
        }
    },
    methods: {
        closeWindow() {
            $('.window-client-check-error-4').removeClass('window-open');
            $('body').removeClass('blocked');
            this.addresseeEmail = '';
            this.newEmail = '';
            this.emailIncorrect = false;
        },
        sendLetter() {
            let emails = [];
            if (this.newEmail.length > 0 && this.correctEmail) {
                emails.push(this.newEmail);
            }
            if (this.addresseeEmail !== '') {
                emails.push(this.addresseeEmail);
            }

            this.$emit('resendLetterToNewEmail', this.letter, emails);
            this.closeWindow();
        },
        getRecepients(recepientList) {
            if (recepientList) {
                return recepientList.split(',').join(', ');
            }
            return "";
        }
    }
}
</script>

<style scoped>

</style>